import React from 'react'
import { HeadingAndContent } from '@boltenergy-be/design-system'
import styles from './PlentySection.module.scss'
import Link from 'components/link/Link'
import { PLENTY_URL } from 'constants/constants'
import { useTranslation } from 'next-i18next/pages'
import { PlentySectionProps } from './types'
import { useRouter } from 'next/router'

const PlentySection = ({ description, title }: PlentySectionProps) => {
  const { t } = useTranslation('common')

  // Router
  const { locale } = useRouter()

  return (
    <HeadingAndContent
      as="section"
      classnames={{ container: styles['plenty-container'] }}
      color="accent-warm"
      inset
      shape="s4"
      shapeTheme="plenty"
      title={title}
      id="plenty"
    >
      <p>{description}</p>
      <Link
        as="a"
        className={styles['plenty-button']}
        href={`${PLENTY_URL}/${locale}?simulation_so=Bolt%20website`}
        representation="button"
        trailingIcon="chevronRight"
      >
        {t('common:goToPlentyWebsite')}
      </Link>
    </HeadingAndContent>
  )
}

export default PlentySection
